import { render } from "./Order.vue?vue&type=template&id=65cd37d5"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=65cd37d5&lang=scss"
const cssModules = {}
import style1 from "./Order.vue?vue&type=style&index=1&id=65cd37d5&lang=scss&module=s"
cssModules["s"] = style1

import exportComponent from "/usr/share/nginx/production/driver/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__